import React from "react";
import { Link } from "react-router-dom";
import { services } from "../data/mock";
import { ArrowUpRight } from "lucide-react";

const ACCENTS = ["#3b9dff", "#f59e0b", "#10b981", "#f43f5e", "#8b5cf6"];

const Card = ({ s, i = 0 }) => {
  const accent = ACCENTS[i % ACCENTS.length];
  return (
  <Link
    to={s.id === "rocky-mount-nc" ? "/rocky-mount-nc" : `/services/${s.id}`}
    className={`group relative rounded-2xl overflow-hidden h-[240px] shadow-md ${
      s.wide ? "lg:col-span-3" : "lg:col-span-2"
    }`}
  >
    <img
      src={s.image}
      alt={s.title}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0a1a35]/90 via-[#0a1a35]/30 to-transparent" />
    <span className="absolute top-0 left-0 h-1.5 w-full" style={{ backgroundColor: accent }} />
    <div className="absolute inset-0 p-6 flex flex-col justify-end">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h3 className="text-white text-xl md:text-2xl font-bold leading-tight">
            {s.title}
          </h3>
          <p className="text-slate-200 text-sm mt-2 max-w-md opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
            {s.desc}
          </p>
        </div>
        <span
          className="shrink-0 w-11 h-11 rounded-full bg-white/15 backdrop-blur flex items-center justify-center transition-colors group-hover:[background-color:var(--accent-c)]"
          style={{ "--accent-c": accent }}
        >
          <ArrowUpRight className="w-5 h-5 text-white" />
        </span>
      </div>
    </div>
  </Link>
  );
};

const ServicesGrid = () => {
  return (
    <section id="services" className="section-pad bg-white">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a1f44]">
            Our Services
          </h2>
          <p className="text-slate-500 mt-3 max-w-2xl mx-auto">
            From TV mounting to full home cinema builds, we handle every part of
            your home technology setup.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-6">
          {services.map((s, i) => (
            <Card key={s.id} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
